import $axios from './index'
// 设备列表
export function getDeviceList(params) {
    const url = '/api/bi/basic/get_device_list'
    return $axios.get(url, params)
}

// 获取所有景区列表
export function getStoreList(params) {
    return $axios.get('/api/bi/basic/get_company_list', params);
}
// 获取数据
export function getdata(data) {
    // return $axios.get('/data/queryStoreList', params);
    return $axios.get('/api/bi/data_statistics/get_order_data', data);
}
// 下载商品数据总览表
export function productdown(params) {
    // 通过传递配置对象来设置 responseType
    return $axios.get('/api/bi/data_statistics/export_goods_summary', params, 'blob');
}

// 下载设备商品数据总览表
export function productdevicedown(params) {
    // 通过传递配置对象来设置 responseType
    return $axios.get('/api/bi/data_statistics/export_device_goods_summary', params, 'blob');
}

// 下载设备商品数据明细表
export function productdevicedetaildown(params) {
    // 通过传递配置对象来设置 responseType 和 transformResponse
    return $axios.get('/api/bi/data_statistics/export_device_goods_detail', params, 'blob');
}



// post(url, data,params) {
//     return $axios({
//       method: 'post',
//       url,
//       data,
//       params: params,  // 将参数放在 URL 的 query 中
//       headers: {
//         'Content-Type': 'application/json; charset=UTF-8',
//       }
//     })
//   },

// post(url, data) {
//   return $axios({
//     method: 'post',
//     url,
//     params: data,  // 将参数放在 URL 的 query 中
//     headers: {
//       'Content-Type': 'application/json; charset=UTF-8',
//     },
//     responseType: 'blob', // 设置 responseType 为 'blob'
//   });
// },